import { render } from "./App.vue?vue&type=template&id=5662a45a"
const script = {}
script.render = render

export default script